export const DEFAULT_PRODUCT_IMAGE =
  'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0ODY0MzV8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwcHJvZHVjdHN8ZW58MHx8fHwxNzU5MjIzMzMwfDA&ixlib=rb-4.1.0&q=80&w=1080';
export const DEFAULT_PRODUCT_NAME = 'Product name';
export const DEFAULT_PRODUCT_DESCRIPTION = 'lorem ipsum lorem ipsum lorem ipsum';
export const DEFAULT_PRODUCT_CTA_TEXT = 'Buy now';
